module.exports = __webpack_public_path__ + "media/baroque.afb1bde3.mp3";